import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditor = () => {
  const [editorContent, setEditorContent] = useState("");

  useEffect(() => {
    const savedContent = localStorage.getItem('editorContent');
    if (savedContent) {
      setEditorContent(savedContent);
    }
  }, []);

  const handleChange = (value) => {
    setEditorContent(value); 
    localStorage.setItem('editorContent', value); 
  };

  const handleSave = () => {

    console.log('Saved Content:', editorContent);
  };

  return (
    <div>
      <h2>Text Editor</h2>
      <ReactQuill
        value={editorContent}
        onChange={handleChange}
      />
      <button onClick={handleSave}>Save Content</button>
    </div>
  );
};

export default TextEditor;
